import { createMuiTheme } from '@material-ui/core/styles';

export const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#FFD100',
            light: '#FEEFC2',
        },
    },
    typography: {
        fontFamily: 'Titillium Web, sans-serif',
        h1: {
            fontSize: '2.12rem',
            lineHeight: '2.2rem',
        },
        h2: {
            fontSize: '1.8rem',
            lineHeight: '2.2rem',
        },
        h3: {
            fontSize: '1.6rem',
            lineHeight: '2.2rem',
        },
        h4: {
            fontSize: '1.4rem',
            lineHeight: '2rem',
        },
        h5: {
            fontSize: '1.2rem',
        },
        body1: {
            fontSize: '1.2rem',
        },
    },
    overrides: {
        MuiTable: {
            root: {
                fontSize: '1.6rem',
            },
        },
        MuiTableCell: {
            head: {
                fontSize: '1.6rem',
                fontWeight: 600,
            },
            body: {
                fontSize: '1.4rem',
                fontWeight: 400,
            },
        },
        MuiStepLabel: {
            label: {
                  fontSize: 16
              },
            iconContainer: {
                width: '30px',
                height: '30px'
            }
          },
        MuiStepIcon: {
            root: {
                width: '30px',
                height: '30px',
                color: 'lightgray'
            },
            text: {
                fontSize: '12px',
                fill: 'white',
            },
            active: {
                '& $text': {
                  fill: 'black',
                },
            },
        }
    },
});



// WEBPACK FOOTER //
// ./styles/theme.js